<template>
  <div class="report-info-bar">
      <div class="report-info-bar-content">
          <label class="report-info-label" v-for="(item,index) in data.infos" :style="item.css" :key="index">
            <!--<i :class="item.prefix.value" v-if="item.prefix &&item.prefix.type==='icon'"></i>-->
            <!--<span class="prefix"  v-else-if="item.prefix"> {{item.prefix.value}}</span>-->
            <span class="report-info-title" v-if="item.title">{{item.title}}</span>{{item.value?item.value: item.defaultValue}}
            <!--<i :class="item.suffix.value" v-if="item.suffix &&item.suffix.type==='icon'" :style="item.suffix.css"></i>-->
            <!--<span class="suffix" v-else-if="item.suffix">{{item.suffix.value}}</span>-->
          </label>
          <div class="report-info-actions" v-if="data.actions">
              <label class="report-info-label" v-for="(item,index) in data.actions" :style="item.css" :key="index" @click="clickButton(item.event)">
                <i :class="item.icon" v-if="item.icon"></i>{{item.value?item.value: item.defaultValue}}
              </label>
          </div>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'report-info-bar',
    props: {
      data: Object
    },
    methods: {
      clickButton(event, $event) {
        const script = event.script
        switch (event.type) {
          case 'router':
            if (event.configKey) {
              event.path = '/config/' + encodeURIComponent(event.configKey)
            }
            this.$router.push({
              path: event.path
            })
            break
          case 'cancel':
            this.goBack()
            break
          case 'custom':
            if (~script.indexOf('function')) {
              const Fn = Function
              new Fn('return ' + script)()()
            } else {
              window[script] && window[script]()
            }
            break
          default:
            this.$emit('button-method', event, this.isDialog)
            break
        }
      },
      resetInfoVal(newData) {
        if (this.data.infos && this.data.infos.length >= 1) {
          this.data.infos.forEach((item) => {
            const key = item.name
            if (newData[key]) {
              item.value = newData[key]
            }
          })
        }
      }
    },
    created() {
      this.$bus.$on('report-info-bar-data', (data) => {
        if (data) {
          this.resetInfoVal(data)
        }
        console.log('report-info-bar-data##:    ' + JSON.stringify(data))
      })
    },
    computed: {}
  }
</script>
<style type="text/scss" lang="scss">
  .report-info-bar {
    width: 100%;
    padding: 0px 30px;
    font-size: 14px;
    min-height: 30px;
    .report-info-bar-content{
      padding: 0px 0px;
      border-bottom: 1px solid #E6E6E6;
      width: 100%;
      display: flex;
      align-items: flex-end;
      position: relative;
      .report-info-label {
        padding: 5px;
        margin-left: 15px;
        .report-info-title{
          font-color: #939393;
          font-size: inherit;
        }
      }
      .report-info-actions{
        position: absolute;
        bottom: 5px;
        right: 15px;
        width: 100%;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/report/components/reportInfo.vue